import {library} from "@fortawesome/fontawesome-svg-core";
import {faApple} from "@fortawesome/free-brands-svg-icons/faApple";
import {faGoogle} from "@fortawesome/free-brands-svg-icons/faGoogle";
import {faWaze} from "@fortawesome/free-brands-svg-icons/faWaze";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons/faArrowDown";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons/faArrowRight";
import {faArrowTrendUp} from "@fortawesome/free-solid-svg-icons/faArrowTrendUp";
import {faAsterisk} from "@fortawesome/free-solid-svg-icons/faAsterisk";
import {faBan} from "@fortawesome/free-solid-svg-icons/faBan";
import {faBell} from "@fortawesome/free-solid-svg-icons/faBell";
import {faBook} from "@fortawesome/free-solid-svg-icons/faBook";
import {faBoxArchive} from "@fortawesome/free-solid-svg-icons/faBoxArchive";
import {faBuilding} from "@fortawesome/free-solid-svg-icons/faBuilding";
import {faCalendar} from "@fortawesome/free-solid-svg-icons/faCalendar";
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import {faCat} from "@fortawesome/free-solid-svg-icons/faCat";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import {faCheckSquare} from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons/faChevronDown";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons/faChevronRight";
import {faChevronUp} from "@fortawesome/free-solid-svg-icons/faChevronUp";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import {faClipboardList} from "@fortawesome/free-solid-svg-icons/faClipboardList";
import {faCloud} from "@fortawesome/free-solid-svg-icons/faCloud";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faCopy} from "@fortawesome/free-solid-svg-icons/faCopy";
import {faDog} from "@fortawesome/free-solid-svg-icons/faDog";
import {faDollarSign} from "@fortawesome/free-solid-svg-icons/faDollarSign";
import {faDownload} from "@fortawesome/free-solid-svg-icons/faDownload";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons/faEnvelope";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import {faExternalLink} from "@fortawesome/free-solid-svg-icons/faExternalLink";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import {faEye} from "@fortawesome/free-solid-svg-icons/faEye";
import {faEyeSlash} from "@fortawesome/free-solid-svg-icons/faEyeSlash";
import {faFile} from "@fortawesome/free-solid-svg-icons/faFile";
import {faFileCsv} from "@fortawesome/free-solid-svg-icons/faFileCsv";
import {faFileInvoiceDollar} from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons/faFilePdf";
import {faFlag} from "@fortawesome/free-solid-svg-icons/faFlag";
import {faFolderOpen} from "@fortawesome/free-solid-svg-icons/faFolderOpen";
import {faHand} from "@fortawesome/free-solid-svg-icons/faHand";
import {faHdd} from "@fortawesome/free-solid-svg-icons/faHdd";
import {faHeart} from "@fortawesome/free-solid-svg-icons/faHeart";
import {faHome} from "@fortawesome/free-solid-svg-icons/faHome";
import {faHorse} from "@fortawesome/free-solid-svg-icons/faHorse";
import {faList} from "@fortawesome/free-solid-svg-icons/faList";
import {faLocationArrow} from "@fortawesome/free-solid-svg-icons/faLocationArrow";
import {faLock} from "@fortawesome/free-solid-svg-icons/faLock";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import {faMoneyBillTrendUp} from "@fortawesome/free-solid-svg-icons/faMoneyBillTrendUp";
import {faPen} from "@fortawesome/free-solid-svg-icons/faPen";
import {faPencilAlt} from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import {faPhone} from "@fortawesome/free-solid-svg-icons/faPhone";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {faRoad} from "@fortawesome/free-solid-svg-icons/faRoad";
import {faSave} from "@fortawesome/free-solid-svg-icons/faSave";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faSignInAlt} from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import {faSms} from "@fortawesome/free-solid-svg-icons/faSms";
import {faSort} from "@fortawesome/free-solid-svg-icons/faSort";
import {faSquare} from "@fortawesome/free-solid-svg-icons/faSquare";
import {faSync} from "@fortawesome/free-solid-svg-icons/faSync";
import {faTachometerAlt} from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import {faTasks} from "@fortawesome/free-solid-svg-icons/faTasks";
import {faThList} from "@fortawesome/free-solid-svg-icons/faThList";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import {faUser} from "@fortawesome/free-solid-svg-icons/faUser";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons/faUserCircle";
import {faUserCog} from "@fortawesome/free-solid-svg-icons/faUserCog";
import {faUserPlus} from "@fortawesome/free-solid-svg-icons/faUserPlus";
import {faUsers} from "@fortawesome/free-solid-svg-icons/faUsers";
import {faWrench} from "@fortawesome/free-solid-svg-icons/faWrench";
export const loadIcons = () => {
  library.add(
    faBuilding,
    faCheckCircle,
    faExternalLink,
    faArrowDown,
    faExternalLinkAlt,
    faPhone,
    faSms,
    faCheckSquare,
    faSquare,
    faMoneyBillTrendUp,
    faCircleInfo,
    faExclamationCircle,
    faArrowTrendUp,
    faCopy,
    faSort,
    faEye,
    faEyeSlash,
    faFileCsv,
    faFolderOpen,
    faDownload,
    faCalendar,
    faSync,
    faBan,
    faTrash,
    faArrowLeft,
    faPen,
    faArrowRight,
    faSave,
    faPlus,
    faPencilAlt,
    faHand,
    faUser,
    faTachometerAlt,
    faHeart,
    faList,
    faLocationArrow,
    faTasks,
    faBook,
    faBan,
    faHdd,
    faLock,
    faSignInAlt,
    faSignOutAlt,
    faWrench,
    faThList,
    faUserPlus,
    faAsterisk,
    faFlag,
    faBell,
    faHome,
    faCalendarAlt,
    faUsers,
    faHorse,
    faDog,
    faCat,
    faFilePdf,
    faUserCircle,
    faGoogle,
    faCog,
    faCheck,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faFile,
    faTimes,
    faDollarSign,
    faCircleNotch,
    faEnvelope,
    faClipboardList,
    faFileInvoiceDollar,
    faRoad,
    faCloud,
    faTimesCircle,
    faSearch,
    faMapMarkerAlt,
    faUserCog,
    faTriangleExclamation,
    faWaze,
    faApple,
    faBoxArchive
  );
};
